import { Doughnut } from 'vue-chartjs'

export default {

  extends: Doughnut,

  props: [
    'data',
    'options'
  ],

  mounted() {
    let { data, options } = this
    this.renderChart(data, {
      ...options,
      responsive: true,
      maintainAspectRatio: true,
    })
  }

}
